import styled from "styled-components/macro";
import { COLORS } from "../../../../layout/theme";
import { Table } from "antd";

export const InnerForm = styled.div`
	display: flex;
	gap: 50px;

	/* Inputs dentro de la tabla */
	.ant-input,
	.ant-input-affix-wrapper,
	.ant-input-number,
	.ant-select-selector {
		border-radius: 12px !important;
		border: 1px solid #d1d5db !important;
		box-shadow: none !important;
		min-height: 32px;
	}

	.ant-input {
		padding: 0 12px;
	}

	.ant-input:hover,
	.ant-input-affix-wrapper:hover,
	.ant-input-number:hover,
	.ant-select-selector:hover {
		border-color: ${COLORS.DarkGrey} !important;
	}

	.ant-input:focus,
	.ant-input-focused,
	.ant-input-affix-wrapper-focused,
	.ant-input-number-focused,
	.ant-select-focused .ant-select-selector {
		border-color: ${COLORS.DarkGrey} !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	/* Para los Input con addonAfter (% / un.) */
	.ant-input-group-wrapper {
		border-radius: 12px !important;
	}

	.ant-input-group {
		border-radius: 12px !important;
	}

	.ant-input-group .ant-input {
		border-radius: 12px 0 0 12px !important;
	}

	.ant-input-group-addon {
		border-radius: 0 12px 12px 0 !important;
		border: 1px solid #d1d5db !important;
		border-left: 0 !important;
		background: #f8fafc !important;
		color: #64748b !important;
		font-weight: 600;
		padding: 0 10px;
	}

	/* Para que el focus se vea correcto también en grupos */
	.ant-input-group-wrapper:hover .ant-input,
	.ant-input-group-wrapper:hover .ant-input-group-addon {
		border-color: ${COLORS.DarkGrey} !important;
	}

	.ant-input-group-wrapper .ant-input:focus + .ant-input-group-addon,
	.ant-input-group-wrapper .ant-input-focused + .ant-input-group-addon {
		border-color: ${COLORS.DarkGrey} !important;
	}
`;
export const LeftSection = styled.div`
	flex: 1 1 65%;
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

export const RightSection = styled.div`
	flex: 1 1 35%;
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

export const PublishSettings = styled.div`
	flex: 0 0 30%;
	background-color: ${COLORS.White};
	padding: 2rem;
	border-radius: 10px;
`;

export const StoreData = styled.div`
	flex: 1 1 40%;
	background-color: ${COLORS.White};
	padding: 2rem;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

export const SectionData = styled.div`
	flex: 1;
	background-color: ${COLORS.White};
	padding: 2rem;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const SalesData = styled.div`
	flex: 0;
	background-color: ${COLORS.White};
	display: flex;
	flex-direction: column;
	padding: 2rem;
	border-radius: 10px;
	gap: 30px;
`;

export const Container = styled.div`
	display: flex;
	gap: 10px;
	padding: 20px 0px;

	.ant-form-item-explain-error {
		white-space: nowrap;
	}
`;

export const BlockedData = styled.div`
	pointer-events: none;
`;

export const BillerContainer = styled.div`
	display: flex;
	width: 100%;
	padding: 1rem;
	gap: 10px;
	background-color: ${COLORS.White};
	border-radius: 20px;
`;

export const BillerAndCodeContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
	align-items: flex-end;
	padding: 10px;
`;

export const BillerSelection = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
	justify-content: center;
`;

export const BillerCode = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
	justify-content: center;
`;

export const AntdTable = styled(Table)`
	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.LightGrey} !important;
		border: none;
	}

	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.White};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}
`;

export const ContainerMails = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 10px;
`;

export const AddMailContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
`;
